import { BrowserRouter, Routes, Route, Outlet, useLocation, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import ProtectedRoute from './ProtectedRoute';
import { Home, Login, Dashboard, Market, Register, ForgotPassword, ReferralProgram, InvestmentOptions, Deposit, DepositBank, Withdrawal, WithdrawalBank, Documents, TwoFactorAuth, CryptoWithdrawals, BankWithdrawals, Deposits, OpenPositions, ClosedPositions, News, NewsDetail, AnnouncementDetail, Promotions, PromotionDetail, NotFound, AboutUs, NordexAcademy, IntroductionText, Vision, Mission, Activities, Management, BlockchainNedir, KriptoParaNedir, KYCNedir, KYCNasilYapilir, VadeliIslemNedir, IkiFaktorluDogrulamaNedir, IkiFaktorluDogrulamaAktif, KriptoRiskleri, KriptoTerimler, SikSorulanSorular } from '../pages';
import Markets from '../pages/Markets';
import AccountSummary from '../pages/AccountSummary';
import ReferralCode from '../pages/ReferralCode';
import ChangePassword from '../pages/ChangePassword';
import TwoFactorLogin from '../components/TwoFactorLogin';
import { Footer, Header } from '../components';

function AppLayout() {
    return (
        <>
            <Header />
            <Outlet />
            <Footer />
        </>
    );
}

function BodyClassController() {
    const location = useLocation();
    useEffect(() => {
        const isAuthPage = location.pathname === '/login' || location.pathname === '/account' || location.pathname === '/forgot-password';
        if (isAuthPage) {
            document.body.classList.add('login-page');
        } else {
            document.body.classList.remove('login-page');
        }
        return () => {
            document.body.classList.remove('login-page');
        };
    }, [location.pathname]);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        // DOM tamamen yüklendikten sonra tekrar scroll
        setTimeout(() => {
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        }, 0);
    }, [location.pathname]);

    return null;
}

function isAuthenticated() {
    try {
        const token = localStorage.getItem('auth:token');
        return !!token;
    } catch {
        return false;
    }
}

function GuestRoute() {
    return isAuthenticated() ? <Navigate to="/account-summary" replace /> : <Outlet />;
}

export default function AppRouter() {
    return (
        <BrowserRouter>
            <BodyClassController />
            <Routes>
                <Route element={<AppLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/markets" element={<Markets />} />

                    {/* Guest-only routes */}
                    <Route element={<GuestRoute />}>
                        <Route path="/login" element={<Login />} />
                        <Route path="/account" element={<Register />} />
                    </Route>

                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/introduction-text" element={<IntroductionText />} />
                    <Route path="/vision" element={<Vision />} />
                    <Route path="/mission" element={<Mission />} />
                    <Route path="/activities" element={<Activities />} />
                    <Route path="/management" element={<Management />} />
                    <Route path="/blockchain-nedir" element={<BlockchainNedir />} />
                    <Route path="/kripto-para-nedir" element={<KriptoParaNedir />} />
                    <Route path="/kyc-nedir" element={<KYCNedir />} />
                    <Route path="/kyc-nasil-yapilir" element={<KYCNasilYapilir />} />
                    <Route path="/vadeli-islem-nedir" element={<VadeliIslemNedir />} />
                    <Route path="/iki-faktorlu-dogrulama-nedir" element={<IkiFaktorluDogrulamaNedir />} />
                    <Route path="/iki-faktorlu-dogrulama-aktif" element={<IkiFaktorluDogrulamaAktif />} />
                    <Route path="/kripto-riskleri" element={<KriptoRiskleri />} />
                    <Route path="/kripto-terimler" element={<KriptoTerimler />} />
                    <Route path="/sik-sorulan-sorular" element={<SikSorulanSorular />} />
                    <Route path="/nordex-academy" element={<NordexAcademy />} />
                    <Route path="/referral-program" element={<ReferralProgram />} />
                    <Route path="/investment-options" element={<InvestmentOptions />} />
                    <Route path="/news" element={<News />} />
                    <Route path="/news/:slug/:id" element={<NewsDetail />} />
                    <Route path="/announcements/:slug/:id" element={<AnnouncementDetail />} />
                    <Route path="/promotions" element={<Promotions />} />
                    <Route path="/promotions/:slug/:id" element={<PromotionDetail />} />

                    <Route element={<ProtectedRoute />}>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/market" element={<Market />} />
                        <Route path="/account-summary" element={<AccountSummary />} />
                        <Route path="/referral-code" element={<ReferralCode />} />
                        <Route path="/change-password" element={<ChangePassword />} />
                        <Route path="/two-factor-auth" element={<TwoFactorAuth />} />
                        <Route path="/crypto-withdrawals" element={<CryptoWithdrawals />} />
                        <Route path="/bank-withdrawals" element={<BankWithdrawals />} />
                        <Route path="/deposits" element={<Deposits />} />
                        <Route path="/open-positions" element={<OpenPositions />} />
                        <Route path="/closed-positions" element={<ClosedPositions />} />
                        <Route path="/deposit" element={<Deposit />} />
                        <Route path="/deposit-bank" element={<DepositBank />} />
                        <Route path="/withdrawal" element={<Withdrawal />} />
                        <Route path="/withdrawal-bank" element={<WithdrawalBank />} />
                        <Route path="/documents" element={<Documents />} />
                    </Route>
                </Route>
                {/* 2FA Login - Header/Footer olmadan */}
                <Route path="/two-factor-login" element={<TwoFactorLogin />} />
                {/* 404 Sayfası - Tüm tanımlanmamış path'ler için */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    );
}


